import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * The private area has no landing page of its own: it opens the file manager.
 *
 * This replaces the starter's component showcase, which was the demo page the
 * template shipped and never product. Everything it demonstrated still exists
 * in `@repo/ui` — `AsyncPickerSource` in `components/async-pickers.tsx` is the
 * typed contract those pickers take, so the wiring the page illustrated is
 * enforced by the compiler rather than by an example.
 *
 * NO COMPONENT, and the redirect is in `beforeLoad` for the same reason
 * `/files` gives: a route with a component paints it for a frame before the
 * redirect lands.
 *
 * It forwards to `/files` rather than to a folder id because no id is known
 * here. `/files` is the step that resolves the caller's personal folder.
 */
export const Route = createFileRoute('/(private)/(shell)/')({
	beforeLoad: () => {
		throw redirect({ to: '/files' })
	}
})
